import { ReactNode } from 'react';
import { useKeycloak } from './KeycloakAuthProvider';
import { Navigate } from 'react-router';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: string[];
}

export function ProtectedRoute({ children, requiredRoles }: ProtectedRouteProps) {
  const { authenticated, keycloak, initialized } = useKeycloak();

  // Warte auf Initialisierung
  if (!initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Nicht authentifiziert → Login
  if (!authenticated) {
    keycloak?.login();
    return null;
  }

  // Rollen-Prüfung
  if (requiredRoles && requiredRoles.length > 0) {
    const userRoles = keycloak?.tokenParsed?.realm_access?.roles || [];
    const hasRequiredRole = requiredRoles.some(role => userRoles.includes(role));

    if (!hasRequiredRole) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
            <h2 className="text-xl font-semibold text-red-900 mb-2">
              Keine Berechtigung
            </h2>
            <p className="text-red-700">
              Sie haben nicht die erforderlichen Berechtigungen um diese Seite zu sehen.
            </p>
            <p className="text-red-600 text-sm mt-2">
              Erforderliche Rollen: {requiredRoles.join(', ')}
            </p>
          </div>
        </div>
      );
    }
  }

  return <>{children}</>;
}
